module.exports = __webpack_public_path__ + "img/center018.8626bea0.jpg";